import OrderList from './OrderList/OrderList'
import OrderDetails from './OrderDetails/OrderDetails'
import NewOrder from './NewOrder/NewOrder'
import Correction from './NewOrder/Correction'
import Navbar from './Misc/Navbar'
import { Navigate, Outlet, useLocation } from 'react-router'
import RepCodes from './RepCodes/RepCodes'
import { useEffect } from 'react'

const routes = [
  {
    path: '/',
    element: <NavbarOutlet />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/order',
        element: <OrderList />,
      },
      {
        path: '/order/:orderID',
        element: <OrderDetails />,
      },
      {
        path: '/repCodes',
        element: <RepCodes />,
      },
      {
        path: '/order/new',
        element: <NewOrder />,
      },
      {
        path: '/order/correction/:orderID',
        element: <Correction />,
      },
      {
        path: '/order/draft/:orderID',
        element: <Correction draft={true} />,
      },
    ],
  },
]

function NavbarOutlet() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Navbar />
      <Outlet key={pathname} />
    </>
  )
}

function Home() {
  return <Navigate to="/order" />
}

export default routes
